import React from 'react';
import DirectionContext from './context/direction';
import MarketContext from './context/market';
import UserContext from './context/user';
function ComponentConfiguration(props) {
    const { direction = 'ltr', market = null, user = { ineligibility_flag: null, authenticated: false }, children, } = props;
    return (React.createElement(DirectionContext.Provider, { value: direction },
        React.createElement(MarketContext.Provider, { value: market },
            React.createElement(UserContext.Provider, { value: user }, children))));
}
export default ComponentConfiguration;
//# sourceMappingURL=index.js.map